<template>
  <div class="auth-layout-wrap">
    <div class="auth-content">
      <div class="card o-hidden">
        <div class="row">
          <div class="col-md-12">
            <div class="p-4">
              <div class="auth-logo text-center mb-30">
                <img :src="logo" />
              </div>
              <h1 class="mb-3 text-18">Sign In</h1>
              <!--              <ApolloMutation-->
              <!--                :mutation="require('@/graphql/Account/Login.gql')"-->
              <!--                :variables="{-->
              <!--                  user: {-->
              <!--                    email: email,-->
              <!--                    password: password-->
              <!--                  }-->
              <!--                }"-->
              <!--                @done="loginResult"-->
              <!--              >-->
              <!--                <template v-slot="{ mutate }">-->
              <b-form-group label="Email Address" class="text-12">
                <b-form-input
                  v-model="email"
                  class="form-control-rounded"
                  type="text"
                  email
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Password" class="text-12">
                <b-form-input
                  v-model="password"
                  class="form-control-rounded"
                  type="password"
                ></b-form-input>
              </b-form-group>
              <b-button
                type="submit"
                tag="button"
                class="btn-rounded btn-block mt-2"
                variant="primary mt-2"
                @click.prevent="validateLogin()"
              >
                Sign In
              </b-button>
              <!--                </template>-->
              <!--              </ApolloMutation>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import logout from "@/graphql/Account/Logout.gql"
import { mapMutations, mapState } from "vuex"

export default {
  layout: "authentication",
  auth: false,
  name: "Login",
  apollo: {
    user: {
      query: require("@/graphql/Account/GetUser.gql"),
      variables() {
        return { userId: this.userId }
      },
      skip() {
        return !this.userId
      },
      update(data) {
        this.loginResult(data)
      }
    }
  },
  data() {
    return {
      email: "",
      password: "",
      userId: null,
      logo: require("@/assets/images/logo2.png")
    }
  },
  computed: {
    ...mapState({ currentUser: state => state.users.currentUser })
  },
  created() {
    if (this.currentUser) this.logout()
  },
  methods: {
    ...mapMutations({
      setCurrentUser: "setCurrentUser",
      clearCurrentUser: "clearCurrentUser"
    }),
    /**
     * Validates login form
     * @param mutate
     * @returns {ToastObject}
     */
    validateLogin() {
      if (!this.email) return this.$toasted.error("Please enter email")
      if (!this.password) return this.$toasted.error("Please enter password")
      this.login()
    },
    /**
     * Logs the user in with supplied email/password
     * @returns {Promise<ToastObject>}
     */
    async login() {
      const resp = await fetch(
        `${process.env.VUE_APP_SITE_BASE_HTTPS}/authentication/login`,
        {
          method: "POST",
          body: JSON.stringify({
            email: this.email,
            password: this.password
          }),
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      const userId = await resp.text()

      if (!userId) return this.$toasted.error("invalid Credentials")

      this.userId = userId
    },
    /**
     * Logs out current user
     */
    logout() {
      this.$apollo.mutate({
        mutation: logout
      })
      this.clearCurrentUser()
    },
    /**
     * Shows notification based on the login state
     * @param data
     * @returns {ToastObject}
     */
    loginResult(data) {
      if (!data.user || data.error)
        return this.$toasted.error("An error occured")
      this.setCurrentUser(data.user)
      this.$toasted.success("Welcome back!")
      this.$router.push("/")
    }
  }
}
</script>
<style scoped>
.auth-layout-wrap .auth-content {
  min-width: 25rem;
}
.auth-logo img {
  /* height: 100px; */
  width: unset;
  margin-bottom: 1.5rem;
}
</style>
